module.exports = __webpack_public_path__ + "static/media/bitmap-l-u-1@1x.002261a8.png";